/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ManufacturerOptions,
  ManufacturerOptionsParams,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Manufacturer Options
 */
export const manufacturerOptions = (
    params?: MaybeRefOrGetter<ManufacturerOptionsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<ManufacturerOptions>(
      {url: `/filters/manufacturers/options`, method: 'GET',
        params, signal
    },
      );
    }




export const getManufacturerOptionsQueryKey = (params?: MaybeRefOrGetter<ManufacturerOptionsParams>,) => {
    return [
    'filters','manufacturers','options', ...(params ? [params] : [])
    ] as const;
    }


export const getManufacturerOptionsQueryOptions = <TData = Awaited<ReturnType<typeof manufacturerOptions>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ManufacturerOptionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof manufacturerOptions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getManufacturerOptionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof manufacturerOptions>>> = ({ signal }) => manufacturerOptions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof manufacturerOptions>>, TError, TData>
}

export type ManufacturerOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof manufacturerOptions>>>
export type ManufacturerOptionsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Manufacturer Options
 */

export function useManufacturerOptions<TData = Awaited<ReturnType<typeof manufacturerOptions>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ManufacturerOptionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof manufacturerOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getManufacturerOptionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






